export enum WebRTCStatus {
    IDLE = 'idle',
    CONNECTING = 'connecting',
    CONNECTED = 'connected',
    FAILED = 'failed',
    DISCONNECTED = 'disconnected',
}

export interface WebRTCState {
    connection: RTCPeerConnection | null;
    sessionId: string;
    service: string | null;
    cleanupExecuted: boolean;
    streamSet: boolean;
}

export interface WebRTCCallbacks {
    setStatus: (status: WebRTCStatus) => void;
    setError: (error: string | null) => void;
}

export interface WebRTCConnectionContext {
    video: HTMLVideoElement;
    sourceId: string;
    stateRef: { current: WebRTCState };
    callbacks: WebRTCCallbacks;
}

export interface WebRTCCleanupContext {
    video: HTMLVideoElement;
    stateRef: { current: WebRTCState };
}
